export default __webpack_public_path__ + "static/media/bird-AI.8095f5fc.png";